// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SurveySessionValuePostRequest {
    'surveySessionId'?: number;
    'questionId'?: number;
    'answerId'?: number;
    'answerValue'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SurveySessionValuePostRequest>> = [
        {
            "name":     "surveySessionId",
            "baseName": "surveySessionId",
            "type":     "number"
        },
        {
            "name":     "questionId",
            "baseName": "questionId",
            "type":     "number"
        },
        {
            "name":     "answerId",
            "baseName": "answerId",
            "type":     "number"
        },
        {
            "name":     "answerValue",
            "baseName": "answerValue",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SurveySessionValuePostRequest.attributeTypeMap;
    }
}
